import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchRecall = fetchGeneralData<any>(`${ApiSubUrls[Apis.RECALL]}`)
